import React from "react";
import { Box, Typography, Modal } from "@mui/material";
import { ModalDrawerStyles, ModalHeader } from "../../Common/styles/modal";

interface NoteDetailsModalProps {
  open: boolean;
  onClose: () => void;
  note: {
    id: string;
    addedBy: string;
    date: string;
    visibility: string;
    note: string;
    createdAt?: string;
  };
}

const NoteDetailsModal: React.FC<NoteDetailsModalProps> = ({
  open,
  onClose,
  note,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={ModalDrawerStyles}>
        <ModalHeader title="Notes" onCloseClick={onClose} />

        <Box sx={{ pt: 3 }}>
          {/* Metadata */}
          <Box sx={{ mb: 3, display: "flex", gap: 8 }}>
            <Box>
              <Typography
                variant="subtitle1"
                fontWeight={"regular"}
                sx={{ mb: 1 }}
              >
                Added By
              </Typography>
              <Typography variant="subtitle1">{note.addedBy || "-"}</Typography>
            </Box>
            <Box>
              <Typography
                variant="subtitle1"
                fontWeight={"regular"}
                sx={{ mb: 1 }}
              >
                Date
              </Typography>
              <Typography variant="subtitle1">{note.date || "-"}</Typography>
            </Box>
            <Box>
              <Typography
                variant="subtitle1"
                fontWeight={"regular"}
                sx={{ mb: 1 }}
              >
                Visibility
              </Typography>
              <Typography variant="subtitle1" textTransform="capitalize">
                {note.visibility || "-"}
              </Typography>
            </Box>
          </Box>

          {/* Note Content */}
          <Box>
            <Typography
              variant="body1"
              color="text.primary"
              fontWeight="regular"
              sx={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {note.note || "-"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default NoteDetailsModal;
